import React from "react";
import { Link } from "react-router-dom";
import ExternalLink from "./ExternalLink";

type ConditionalLinkProps = {
    to: string;
    isExternal: boolean;
    children: React.ReactNode;

    className?: string;
    onClick?: (() => void);
}

const ConditionalLink: React.FC<ConditionalLinkProps> = (props) => {

    if (props.to == null || props.to.length === 0) {
        return <span className={props.className} onClick={props.onClick}>{props.children}</span>;
    }

    return props.isExternal
        ? <ExternalLink url={props.to} hideExternalIcon {...props}>{props.children}</ExternalLink>
        : <Link {...props}>{props.children}</Link>
}

export default ConditionalLink;